<script lang="ts">
  import type { Snippet } from 'svelte';

  // Fixed, cursor/cell-anchored tooltip container shared by the chart hover
  // tooltips (heatmap, cohort heatmap, weekly trend, role flow, best-time clock).
  // `x`/`y` are client coords of the anchor point; the card renders centered above
  // it and escapes any overflow (position: fixed). `class` overrides width/padding.
  let {
    x,
    y,
    class: cls = 'w-56 px-3 py-2.5',
    children,
  }: { x: number; y: number; class?: string; children: Snippet } = $props();
</script>

<div
  class="pointer-events-none fixed z-50 -translate-x-1/2 -translate-y-full rounded-box border hair bg-base-100 shadow-xl {cls}"
  style="left:{x}px; top:{y - 10}px"
  role="tooltip"
>
  {@render children()}
</div>
